<section class="shipDetails" *ngIf="shipDetailsbasicinfo?.vslName" [ngClass]="[selectedPagetab === 'overview' && isScrubberVisible?.currentScrubberUsage ? 'overViewclassadded' : '',
selectedPagetab === 'overview' ? 'overClassonly' : '',penaltyHistory ? 'penaltyHistoryClass' : '',selectedPagetab === 'pointsManagement' ? 'pointsMngClass' : '' ]">
  <div class="shipDetailsHeader">
    <div class="breadcum body-b">{{shipDetailsbasicinfo?.fleet}} Fleet management / <span (click)="goBackToPool()">Pool {{shipDetailsbasicinfo?.subPool}}</span> / {{shipDetailsbasicinfo?.vslName}}
    <span *ngIf="penaltyHistory" class="penaltyHistoryBreadcum"> / Penalty history</span>
    </div>
    <span >
      <figure>
        <img alt="left-icon" src="/assets/img/chevron-left.svg" (click)="goBack()">
      </figure>
    </span>
    <ng-container *ngIf="!penaltyHistory">
      <div class="shipheaderName" (click)="goBack()">{{shipDetailsbasicinfo?.vslName}}</div>
      <div class="lastUpdated fleet-section-title sub-heading-s1"><span class="lastupdate body-b">Last update:</span>
        {{shipDetailsbasicinfo?.lastUpdatedByFirstName}} {{shipDetailsbasicinfo?.lastUpdatedByLastName}} ({{shipDetailsbasicinfo?.lastUpdatedByInitials}}),
        {{shipDetailsbasicinfo?.updatedAt | date:'d MMMM y, H:mm' : 'UTC' }} UTC
      </div>
    </ng-container>
    <ng-container *ngIf="penaltyHistory">
      <div class="shipheaderName" (click)="goBack()">Penalty history</div>
    </ng-container>
  </div>
  <div class="CommonContainerCardFleet border__radius8" >
    <div class="tab" *ngIf="!penaltyHistory">
      <snl-page-tab class="overviewTab" [isSelected]="selectedPagetab === 'overview' ? true : false "
        (onPageTabClick)="clickTab('overview')">Overview</snl-page-tab>
      <ng-container>
        <snl-page-tab class="pointsTab" [isSelected]="selectedPagetab === 'pointsManagement' ? true : false "
          (onPageTabClick)="clickTab('pointsManagement')">Points management</snl-page-tab>
      </ng-container>
    </div>
    <ng-container *ngIf="selectedPagetab === 'overview'">
      <div *ngIf="shipDetailsbasicinfo?.vslName">
        <app-overview [shipDetailsbasicinfo]="shipDetailsbasicinfo" (isScrubberVisible)="showScrubber($event)"></app-overview>
        <div class="pointsBox" [ngClass]="overViewScrubberPointInterface.isLoader ? 'addedScrubberclass' : ''">
          <p class="subHeading sub-heading-s1">Points</p>
          <div class="fleet-body-b3 editable body-b">
            <span class="editable">Editable in </span>
            <a (click)="clickTab('pointsManagement')" class="pointsMang sub-heading-s1 editable">Points management</a>
            <span class="editable"> tab</span>
          </div>
          <ul class="points-basic-info">
            <li class="basic-row">
              <div class="fleet-ship-col-width">
                <p class="fleet-body-b3 body-b">Pool points</p>
                <div class="Skelton-section" *ngIf="overViewPoolPointInterface?.isLoader">
                  <div class="sektion-filter"><span class="Skelton-pp"></span></div>
                </div>
                <ng-container *ngIf="!overViewPoolPointInterface?.isLoader">
                  <p class="fleet-section-title section-title fw-700">{{shipDetailsbasicinfo?.poolPoint | negativeToBracket}}</p>
                </ng-container>
              </div>
              <div class="fleet-ship-col-width">
                <p class="fleet-body-b3 body-b">Penalty</p>
                <div class="Skelton-section" *ngIf="overViewPenaltyInterface?.isLoader">
                  <div class="sektion-filter"><span class="Skelton-pp"></span></div>
                </div>
                <ng-container *ngIf="!overViewPenaltyInterface?.isLoader">   
                  <p class="fleet-section-title section-title fw-700" *ngIf="shipDetailsbasicinfo?.isPenaltyOngoing">
                    {{addPenaltydetails?.penaltyPercentage ? addPenaltydetails?.penaltyPercentage :
                    shipDetailsbasicinfo?.penaltyPercentage | negativeToBracket}}%</p>
                  <p class="fleet-section-title section-title fw-700" *ngIf="!shipDetailsbasicinfo?.isPenaltyOngoing">-</p>
                </ng-container>
              </div>
            </li>
            <!-- <li class="basic-row" *ngIf="shipDetailsbasicinfo?.scrubberFitted"> -->
            <li class="basic-row" *ngIf="isScrubberVisible?.currentScrubberUsage">
              <div class="scrubber-width">
                <p class="fleet-body-b3 body-b">Scrubber points</p>
                <div class="Skelton-section" *ngIf="overViewScrubberPointInterface?.isLoader">
                  <div class="sektion-filter"><span class="Skelton-pp"></span></div>
                </div>
                <ng-container *ngIf="!overViewScrubberPointInterface?.isLoader">
                  <p class="fleet-section-title section-title fw-700">{{isScrubberVisible?.currentScrubberPoints | negativeToBracket}}</p>
                </ng-container>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="selectedPagetab == 'pointsManagement'">
      <app-points-management *ngIf="poolPointDetails"
       [shipDetailsbasicinfo]="shipDetailsbasicinfo"
       [poolPointDetails]="poolPointDetails"
       [scrubberPointDetails]="scrubberPointDetails"
       [isScrubberVisible]="isScrubberVisible"
       >
      </app-points-management>
    </ng-container>
  
  
  </div>

</section>



